// src/lib/conference/ios-warmup.ts
// SP0-Mitnahme: iOS schaltet beim Audio-Session-Start die Hardware-Sample-Rate um (44,1 ↔ 48 kHz);
// vor dem Umschalten gerenderte Buffer spielen kurz pitch-verschoben ("Chipmunk"). Einmal vor dem
// Join einen winzigen stillen Buffer rendern → Session ist auf der finalen Rate, kein Blip am 1. Wort.
export async function warmUpAudioSession(): Promise<void> {
  type ACtor = typeof AudioContext;
  const Ctor: ACtor | undefined = window.AudioContext ?? (window as unknown as { webkitAudioContext?: ACtor }).webkitAudioContext;
  if (!Ctor) return;
  const ctx = new Ctor();
  try {
    if (ctx.state === 'suspended') await ctx.resume();
    const buf = ctx.createBuffer(1, 1, ctx.sampleRate);
    const src = ctx.createBufferSource();
    src.buffer = buf;
    src.connect(ctx.destination);
    src.start(0);
    await new Promise((r) => setTimeout(r, 60));
  } catch { /* best effort */ }
  finally { try { await ctx.close(); } catch { /* ignore */ } }
}
